module.exports = __webpack_public_path__ + "static/media/apple.de9b1a8a.png";